import { getUserInitials, type UserNameSource } from "../../utils/userIdentity";

interface Props {
  user?: UserNameSource | null;
  /** Clases del icono neutro que se muestra cuando no hay iniciales. */
  iconClassName?: string;
}

/**
 * Contenido del avatar del usuario en sesión: sus iniciales reales o, si no hay
 * nombre ni correo de dónde sacarlas, un icono neutro de persona. Nunca
 * iniciales inventadas. El círculo (tamaño, color) lo pone quien lo usa.
 */
export default function UserInitials({ user, iconClassName = "" }: Props) {
  const initials = getUserInitials(user);
  if (initials) return <>{initials}</>;
  return (
    <i
      className={`ri-user-line font-normal ${iconClassName}`.trim()}
      aria-hidden="true"
      data-testid="user-initials-icon"
    />
  );
}
